/* Quick add to cart + wishlist (Lotfy, 2026-10-20). Works alongside theme.js without changing it:
   the theme opens/closes the Quick add drawer through its own [data-drawer-open] / [data-drawer-close]
   handlers, and the cart drawer is opened by clicking the header cart link ([data-cart-open]). */
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {} };
  var WISH_KEY = 'lotfy:wishlist';
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var root = theme.routes.root || '/';

  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  /* ------------------------------------------------------------------
     Wishlist (saved in this browser)
  ------------------------------------------------------------------ */
  var Wishlist = {
    get: function () {
      try {
        var list = JSON.parse(window.localStorage.getItem(WISH_KEY) || '[]');
        return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string' && h; }) : [];
      } catch (e) { return []; }
    },

    save: function (list) {
      try { window.localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) {}
      this.sync();
    },

    has: function (handle) { return this.get().indexOf(handle) > -1; },

    toggle: function (handle) {
      var list = this.get();
      var i = list.indexOf(handle);
      if (i > -1) list.splice(i, 1);
      else list.unshift(handle);
      this.save(list);
      return i === -1;
    },

    sync: function () {
      var list = this.get();
      $$('[data-wish-toggle]').forEach(function (btn) {
        var on = list.indexOf(btn.getAttribute('data-handle')) > -1;
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.setAttribute('aria-label', btn.getAttribute('aria-label').replace(/^(Add to|Remove from) wishlist/, on ? 'Remove from wishlist' : 'Add to wishlist'));
      });
      $$('[data-wishlist-count]').forEach(function (el) {
        el.textContent = list.length;
        el.classList.toggle('is-empty', list.length === 0);
      });
    },

    renderPage: function () {
      var grid = $('[data-wishlist-grid]');
      if (!grid) return;
      document.title = document.title.replace(/^[^–]*/, 'Wishlist ');
      var empty = $('[data-wishlist-empty]');
      var list = this.get();
      var self = this;
      if (!list.length) { empty.hidden = false; return; }
      Promise.all(list.map(function (handle) {
        return fetch(root + 'products/' + encodeURIComponent(handle) + '?section_id=wishlist-card')
          .then(function (r) { return r.ok ? r.text() : null; })
          .then(function (html) { return html ? parseHTML(html).querySelector('[data-wish-item]') : null; })
          .catch(function () { return undefined; });
      })).then(function (items) {
        // Drop products that no longer exist (404); keep ones that only failed to load
        var gone = list.filter(function (h, i) { return items[i] === null; });
        if (gone.length) self.save(self.get().filter(function (h) { return gone.indexOf(h) === -1; }));
        items.forEach(function (li) { if (li) grid.appendChild(li); });
        empty.hidden = grid.children.length > 0;
        self.sync();
      });
    }
  };

  /* ------------------------------------------------------------------
     Cart
  ------------------------------------------------------------------ */
  // One add request at a time: repeated taps while a request is running are ignored, so nothing is added twice.
  var adding = false;

  function addToCart(variantId, quantity, toCheckout) {
    if (adding) return Promise.resolve(false);
    adding = true;
    return fetch((theme.routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity || 1 }], sections: 'cart-drawer', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || theme.strings.cartError || 'Error');
        if (toCheckout) {
          // stays locked: the page is leaving for Shopify Checkout
          window.location.href = (theme.routes.root || '/') + 'checkout';
          return true;
        }
        return refreshDrawer(res.data.sections && res.data.sections['cart-drawer']).then(function () {
          adding = false;
          openCart();
          return true;
        });
      })
      .catch(function (err) {
        adding = false;
        // Shopify may have added part of the quantity (stock limit): keep the cart drawer and counts in step
        refreshDrawer();
        throw err;
      });
  }

  function refreshDrawer(html) {
    return (html ? Promise.resolve(html) : fetch(root + '?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (d) { return d['cart-drawer']; }))
      .then(function (drawerHtml) {
        var fresh = drawerHtml && parseHTML(drawerHtml).querySelector('[data-cart-drawer-inner]');
        var current = $('[data-cart-drawer-inner]');
        if (fresh && current) {
          current.replaceWith(fresh);
          var count = parseInt(fresh.getAttribute('data-count'), 10) || 0;
          $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.classList.toggle('is-empty', count === 0); });
          $$('[data-cart-count-inline]').forEach(function (el) { el.textContent = count; });
        }
      })
      .catch(function () {});
  }

  function openCart() {
    var link = $('.header [data-cart-open]') || $('[data-cart-open]');
    if (theme.cartType === 'drawer' && link && $('[data-drawer="cart"]')) link.click();
    else window.location.href = theme.routes.cart || '/cart';
  }

  /* ------------------------------------------------------------------
     Quick add drawer (variant selector)
  ------------------------------------------------------------------ */
  var QuickAdd = {
    load: function (handle) {
      var body = $('[data-qa-body]');
      if (!body) return;
      body.innerHTML = '<p class="qa-loading">…</p>';
      fetch(root + 'products/' + encodeURIComponent(handle) + '?section_id=quick-add-form')
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var form = parseHTML(html).querySelector('[data-qa-form]');
          if (!form) throw new Error('missing form');
          body.innerHTML = '';
          body.appendChild(form);
          QuickAdd.init(form);
          Wishlist.sync();
        })
        .catch(function () { window.location.href = root + 'products/' + encodeURIComponent(handle); });
    },

    init: function (form) {
      var variants = [];
      try { variants = JSON.parse($('[data-qa-variants]', form).textContent); } catch (e) { variants = []; }
      var fieldsets = $$('.variant-picker__option', form);
      var checkoutBtn = $('[data-qa-checkout]', form);
      var cartBtn = $('[data-qa-cart]', form);
      var errorEl = $('[data-qa-error]', form);
      var priceEl = $('[data-qa-price]', form);
      var qtyInput = $('[data-qa-qty-input]', form);
      var defaultPrice = priceEl.innerHTML;
      var checkoutText = checkoutBtn.textContent;
      var cartText = cartBtn.textContent;
      var current = null;
      var missingName = '';

      function selected() {
        return fieldsets.map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
      }

      function maxQty() {
        return current && typeof current.max === 'number' ? Math.max(1, Math.min(current.max, 99)) : 99;
      }

      function quantity() {
        var q = parseInt(qtyInput.value, 10);
        return isNaN(q) || q < 1 ? 1 : Math.min(q, maxQty());
      }

      function clampQty() {
        var q = parseInt(qtyInput.value, 10) || 1;
        var max = maxQty();
        qtyInput.max = max;
        if (q > max) {
          qtyInput.value = max;
          showError('Only ' + max + ' left in this ' + (fieldsets.length ? 'size' : 'item') + '.');
        }
      }

      function showError(msg) {
        errorEl.textContent = msg;
        errorEl.hidden = !msg;
      }

      function update() {
        var options = selected();
        // A value is crossed out when no in-stock variant has it together with the other chosen values
        fieldsets.forEach(function (fs, index) {
          $$('[data-option-input]', fs).forEach(function (input) {
            var ok = variants.some(function (v) {
              return v.available && v.options.every(function (o, i) {
                return i === index ? o === input.value : (options[i] === null || o === options[i]);
              });
            });
            if (input.nextElementSibling) input.nextElementSibling.classList.toggle('is-unavailable', !ok);
          });
          var label = $('[data-option-selected]', fs);
          if (label) label.textContent = options[index] || '';
        });
        var missing = fieldsets.filter(function (fs, i) { return options[i] === null; })[0];
        missingName = missing ? ($('.variant-picker__legend', missing).firstChild.textContent || '').replace(':', '').trim().toLowerCase() : '';
        current = missing ? null : variants.filter(function (v) {
          return v.options.every(function (o, i) { return o === options[i]; });
        })[0] || null;
        priceEl.innerHTML = current ? current.price : defaultPrice;
        showError('');
        var soldOut = !missing && (!current || !current.available);
        checkoutBtn.textContent = soldOut ? (theme.strings.soldOut || 'Sold out') : checkoutText;
        checkoutBtn.disabled = soldOut;
        cartBtn.hidden = soldOut;
        if (!soldOut) clampQty();
      }

      function buy(toCheckout, btn, text) {
        if (missingName) { showError('Please select a ' + missingName + '.'); return; }
        if (!current || !current.available) { showError(theme.strings.soldOut || 'Sold out'); return; }
        checkoutBtn.disabled = true;
        cartBtn.disabled = true;
        btn.textContent = theme.strings.adding || 'Adding…';
        addToCart(current.id, quantity(), toCheckout)
          .then(function (done) {
            if (toCheckout && done) return;
            checkoutBtn.disabled = false; cartBtn.disabled = false; btn.textContent = text;
          })
          .catch(function (err) {
            checkoutBtn.disabled = false; cartBtn.disabled = false; btn.textContent = text;
            showError(err.message);
          });
      }

      form.addEventListener('change', function (e) { if (e.target !== qtyInput) update(); });
      $$('[data-qa-step]', form).forEach(function (b) {
        b.addEventListener('click', function () {
          showError('');
          qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-qa-step'), 10));
          clampQty();
        });
      });
      qtyInput.addEventListener('change', function () { showError(''); clampQty(); });
      checkoutBtn.addEventListener('click', function () { buy(true, checkoutBtn, checkoutText); });
      cartBtn.addEventListener('click', function () { buy(false, cartBtn, cartText); });
      update();
    }
  };

  /* ------------------------------------------------------------------
     Events
  ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var wish = e.target.closest('[data-wish-toggle]');
    if (wish) {
      e.preventDefault();
      var handle = wish.getAttribute('data-handle');
      var added = Wishlist.toggle(handle);
      if (!added) {
        var item = $('[data-wishlist-grid] [data-wish-item="' + handle + '"]');
        if (item) {
          item.remove();
          var empty = $('[data-wishlist-empty]');
          if (empty) empty.hidden = $('[data-wishlist-grid]').children.length > 0;
        }
      }
      return;
    }

    var open = e.target.closest('[data-qa-open]');
    if (open) {
      // theme.js opens the drawer itself (data-drawer-open="quick-add"); we only fill it
      e.preventDefault();
      QuickAdd.load(open.getAttribute('data-handle'));
      return;
    }

    var add = e.target.closest('[data-qa-add]');
    if (add) {
      e.preventDefault();
      if (add.disabled) return;
      var label = $('.qa__label', add);
      var text = label.textContent;
      add.disabled = true;
      add.classList.add('is-busy');
      label.textContent = theme.strings.adding || 'Adding…';
      addToCart(add.getAttribute('data-variant-id'), 1, false)
        .catch(function (err) { window.alert(err.message); })
        .then(function () {
          add.disabled = false;
          add.classList.remove('is-busy');
          label.textContent = text;
        });
    }
  });

  window.addEventListener('storage', function (e) { if (e.key === WISH_KEY) Wishlist.sync(); });

  function boot() {
    Wishlist.sync();
    Wishlist.renderPage();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function () { Wishlist.sync(); });

  // Cards added later (product recommendations, wishlist page) need their hearts set
  if ('MutationObserver' in window) {
    var pending = false;
    new MutationObserver(function (records) {
      if (pending) return;
      var hasCards = records.some(function (r) {
        return Array.prototype.some.call(r.addedNodes, function (n) {
          return n.nodeType === 1 && (n.matches('[data-wish-toggle]') || n.querySelector('[data-wish-toggle]'));
        });
      });
      if (!hasCards) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; Wishlist.sync(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
